/* eslint-disable */

import { APIClient } from "./_api";
const endpoint = "/BlackList";

export function blockOrder(query) {
  return APIClient.post(`${endpoint}/blockOrder`, query);
}

export function addBlackList(data) {
  return APIClient.post(`${endpoint}`, data);
}

export function getBlackList(data) {
  return APIClient.post(`${endpoint}/filter`, data);
}

export function editBlock(data) {
  return APIClient.put(`${endpoint}/${data.id}`, data.values);
}
